import { AddressPopup } from '../map.service';
import { RadarDtg } from 'src/app/radar/radar.service';

import { Pipe, PipeTransform } from '@angular/core';

import { getEopValue } from '../constants/constants';

@Pipe({ name: 'getEopValue' })
export class GetEopValuePipe implements PipeTransform {
  transform(
    parameter: string,
    addressPopup: AddressPopup,
    dtgs: RadarDtg[],
    dtgIndex: number,
    testMode: boolean
  ) {
    return getEopValue(parameter, addressPopup, dtgs, dtgIndex, testMode);
  }
}
